module.exports = __webpack_public_path__ + "img/54.full_garbage_can.0c0206a5.svg";